import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
export var useUserExperienceState = function (user) {
    var axios = useAxios();
    return useQuery(['onboard-date', user], function () { return axios.get("/api/v1/users/".concat(user, "/experience_state")); }, {
        select: function (response) { return response.data.data; },
    });
};
